import { lazy, Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSoyuzExperiment } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

const InteractiveMapMapbox = lazy(() =>
  import('../InteractiveMap/index.mapbox')
);
const InteractiveMapGoogle = lazy(() => import('../InteractiveMap'));
const InteractiveMapWoosmap = lazy(() =>
  import('../InteractiveMap/index.woosmap')
);
const InteractiveMapMaptiler = lazy(() =>
  import('../InteractiveMap/index.maptiler')
);

const pickInteractiveMap = variant => {
  if (variant === 'mapbox') return InteractiveMapMapbox;
  if (variant === 'woosmap') return InteractiveMapWoosmap;
  if (variant === 'maptiler') return InteractiveMapMaptiler;
  return InteractiveMapGoogle;
};

const SliderTrackMap = props => {
  const mapProviderVariant = useSoyuzExperiment('MapProviderWoosmapMapTiler').get(
    'behaviour'
  );
  const InteractiveMap = pickInteractiveMap(mapProviderVariant);

  useEffect(() => {
    SoyuzAnalytics.sendGA4Event('map-loaded', {
      provider: mapProviderVariant,
      section: 'listing-detail'
    });
  }, []);

  return (
    <Suspense fallback={null}>
      <InteractiveMap {...props.item} mapId="slider-map" />
    </Suspense>
  );
};

SliderTrackMap.propTypes = {
  item: PropTypes.shape({
    coords: PropTypes.arrayOf(PropTypes.number),
    countryCode: PropTypes.string,
    areaSlug: PropTypes.string
  }).isRequired
};

export default SliderTrackMap;
